import type { LaneMinimum } from "../../hooks/react-query/backOffice/pricingAndRating/useLaneMinimumList";

// Location Types (for API response)
export const mockLocationTypes = [
  { id: 1, typeName: "Country" },
  { id: 2, typeName: "State" },
  { id: 3, typeName: "Zone" },
];

// Location Values by type (for API response)
export const mockLocationValuesByType: Record<
  string,
  Array<{ code: string; name: string | null }>
> = {
  Country: [
    { code: "US", name: "United States" },
    { code: "CA", name: "Canada" },
    { code: "MX", name: "Mexico" },
  ],
  State: [
    { code: "AL", name: "Alabama" },
    { code: "AK", name: "Alaska" },
    { code: "AZ", name: "Arizona" },
    { code: "AR", name: "Arkansas" },
    { code: "CA", name: "California" },
    { code: "CO", name: "Colorado" },
    { code: "CT", name: "Connecticut" },
    { code: "DE", name: "Delaware" },
    { code: "FL", name: "Florida" },
    { code: "GA", name: "Georgia" },
  ],
  Zone: [
    { code: "Z001", name: "Zone 1" },
    { code: "Z002", name: "Zone 2" },
    { code: "Z003", name: "Zone 3" },
  ],
};

export const mockLaneMinimumList: LaneMinimum[] = [
  {
    id: 1,
    sequence: 1,
    originType: "State",
    originLocation: "CA",
    destinationType: "State",
    destinationLocation: "TX",
    minimumCharge: 150.0,
    direction: "Both Ways",
  },
  {
    id: 2,
    sequence: 2,
    originType: "State",
    originLocation: "CA",
    destinationType: "State",
    destinationLocation: "TX",
    minimumCharge: 150.0,
    direction: "Both Ways",
  },
  {
    id: 3,
    sequence: 3,
    originType: "State",
    originLocation: "CA",
    destinationType: "State",
    destinationLocation: "TX",
    minimumCharge: 150.0,
    direction: "Both Ways",
  },
  {
    id: 4,
    sequence: 4,
    originType: "State",
    originLocation: "CA",
    destinationType: "State",
    destinationLocation: "TX",
    minimumCharge: 150.0,
    direction: "Both Ways",
  },
  {
    id: 5,
    sequence: 5,
    originType: "State",
    originLocation: "CA",
    destinationType: "State",
    destinationLocation: "TX",
    minimumCharge: 150.0,
    direction: "Both Ways",
  },
  {
    id: 6,
    sequence: 6,
    originType: "State",
    originLocation: "CA",
    destinationType: "State",
    destinationLocation: "TX",
    minimumCharge: 150.0,
    direction: "One Way",
  },
  {
    id: 7,
    sequence: 7,
    originType: "State",
    originLocation: "CA",
    destinationType: "State",
    destinationLocation: "TX",
    minimumCharge: 150.0,
    direction: "Both Ways",
  },
  {
    id: 8,
    sequence: 8,
    originType: "State",
    originLocation: "CA",
    destinationType: "State",
    destinationLocation: "TX",
    minimumCharge: 150.0,
    direction: "Both Ways",
  },
  {
    id: 9,
    sequence: 9,
    originType: "State",
    originLocation: "CA",
    destinationType: "State",
    destinationLocation: "TX",
    minimumCharge: 150.0,
    direction: "One Way",
  },
  {
    id: 10,
    sequence: 10,
    originType: "State",
    originLocation: "CA",
    destinationType: "State",
    destinationLocation: "TX",
    minimumCharge: 150.0,
    direction: "Both Ways",
  },
];
